module.exports = __webpack_public_path__ + "img/license-icon-black.bc7f00c9.svg";